
import Vue from 'vue'
export default Vue.extend({
  name: 'CollapsibleAdminOptions',
  props: {
    options: {
      type: Array,
      required: true
    }
  },
  methods: {
    setView(option: any){
      window.location.href = '#adminComponent'
      this.$emit('view', option);
    }
  }
})
